import { ConstructionOutlined } from "@mui/icons-material";
import { useRef, useEffect, useState } from "react";
import { MdHomeFilled, MdKeyboardArrowRight } from "react-icons/md";
import { SiMicrosoftexcel } from "react-icons/si";
import {
  Link,
  Outlet,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import "./my.scss";

function CommitteeMy() {
  const node = useRef();
  const location = useLocation("");
  const [activeTab, setActiveTab] = useState("active_tab");

  if (location.pathname.includes("mycommittee")) {
  }

  // console.log(location.pathname);

  return (
    <>
      <div className="location_wrap">
        <div className="location">
          <Link to="/">
            <MdHomeFilled />
          </Link>
          <MdKeyboardArrowRight />
          {location.pathname.includes("mycommittee") && (
            <Link to="/committeemy/mycommittee">마이페이지</Link>
          )}
          {location.pathname.includes("applicationMycommittee") && (
            <Link to="/committeemy/mycommittee">나의 신청내역</Link>
          )}
          {location.pathname.includes("notification") && (
            <Link to="/committeemy/mycommittee">알림</Link>
          )}
        </div>
      </div>

      <div className="contain my_wrap">
        <div className="my_page" action="" method="">
          <div className="my_page_heading mybreakdown">
            <div className="my_page_heading_inner mybreakdown_inner">
              {location.pathname.includes("mycommittee") ? (
                <Link to="/committeemy/mycommittee" className={activeTab}>
                  마이페이지
                </Link>
              ) : (
                <Link to="/committeemy/mycommittee">마이페이지</Link>
              )}

              {location.pathname.includes("applicationMycommittee") ? (
                <Link
                  to="/committeemy/applicationMycommittee"
                  className={activeTab}
                >
                  위원회 문서
                </Link>
              ) : (
                <Link to="/committeemy/applicationMycommittee">
                  위원회 문서
                </Link>
              )}

              {/* {location.pathname.includes("notification") ? (
                <Link to="/committeemy/notification" className={activeTab}>
                  알림
                </Link>
              ) : (
                <Link to="/committeemy/notification">알림</Link>
              )} */}
            </div>
            <p className="modify_none">
              <span>■</span> 수정불가
            </p>
          </div>

          <Outlet></Outlet>
        </div>
      </div>
    </>
  );
}

export default CommitteeMy;
